import React from 'react';
import { withStyles, Grid, ButtonBase } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import Apis from '../../network/Apis';
import AnchorAvatar from '../anchor/AnchorAvatar';

const ZHUBOBACK = require("../../images/bg/zhubo.png");


class AnchorRank extends React.Component {

    static JUMP_TYPE_H5 = 1;
    static JUMP_TYPE_ANCHOR = 2;
    static JUMP_TYPE_MATCH = 3;


    constructor(props) {
        super(props);
        this.state = {
            anchorRankData: [],
        }
    }

    componentDidMount() {
        this.getAnchorRanking();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getAnchorRanking = async () => {
        let result = await Apis.encryptionHostPaiHang();
        if (result.code == 200) {
            let data = result.data;
            let anchorRankData = [];
            for (let i = 0; i < data.length && i < 3; i++) {
                anchorRankData.push(data[i]);
            }
            this.setState({ anchorRankData: anchorRankData });
        }
    }

    onClick = () => {
        this.props.history.push({ pathname: '/anchorrank' });
    }

    render() {
        const { classes } = this.props;
        const { anchorRankData } = this.state;
        return (
            <ButtonBase disableRipple className={classes.button} onClick={() => this.onClick()} >
                <Grid container direction='row' alignItems='center' className={classes.root}>
                    <Grid container direction='column' justify='flex-end' alignItems='center' className={classes.zhuBackgroud}>
                        <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1 }}>
                            {
                                anchorRankData.map((item, i) => (
                                    <AnchorAvatar key={i} idx={i} avatar={item.portrait} size='11vw' imgStyle={{ marginLeft: '4vw', marginTop: '4vw' }} />
                                ))
                            }
                        </Grid>
                    </Grid>
                    <Grid container direction='row' alignItems='center' className={classes.container}>
                        <ChevronRightOutlinedIcon className={classes.chevron} />
                    </Grid>
                </Grid>
            </ButtonBase>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100vw',
        margin: theme.spacing(0.5, 0, 1, 0),
    },
    container: {
        flex: 1,
        height: 25,
    },
    zhuBackgroud: {
        backgroundSize: 'cover',
        backgroundImage: `url(${ZHUBOBACK})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        width: 'calc(100vw - 36px)',
        height: '14vw',
    },
    icon: {
        width: 48,
        height: 18,
        padding: 0,
        margin: 0,
        margin: theme.spacing(0, 1, 0, 1),
        objectFit: 'scale-down'
    },
    chevron: {
        fontSize: 18,
        color: theme.palette.common.default,
        margin: theme.spacing(0, 1, 0, 1),
    },
    text: {
        fontSize: 11,
        color: theme.palette.common.default,
        flex: 1,
        textAlign: 'left',
        margin: theme.spacing(0, 1, 0, 1),
    },
    button: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        backgroundColor: 'white',
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
    }

}))(AnchorRank));